import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  height: max-content;
  width: 100%;
  padding: 10%;
  background: #fff;
  box-shadow: 2px 2px 5px 1px rgb(0 0 0 / 0.05);
`